import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import { Seo } from 'components/standalone';
import CheckoutFeedback from 'components/checkout/CheckoutFeedback';

const CheckoutFinishedPage = () => {
	const { state }: any = useLocation();
	const history = useHistory();

	useEffect(() => {
		if (!state) {
			history.push('/');
		}
	});

	return (
		<>
			<Seo title={`${process.env.REACT_APP_NAME} - Compra finalizada`} />
			{state && <CheckoutFeedback data={state.data} />}
		</>
	);
}

export default CheckoutFinishedPage;
